webpackJsonp([2706754912605],{

/***/ 1589:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":null},"pathContext":{"author":"/people/faye-prince/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---authors-faye-prince-eb3c56e441ca13fa8dd7.js